import { render, staticRenderFns } from "./Payment-Mode.vue?vue&type=template&id=2e1b1edc"
import script from "./Payment-Mode.vue?vue&type=script&lang=js"
export * from "./Payment-Mode.vue?vue&type=script&lang=js"
import style0 from "./Payment-Mode.vue?vue&type=style&index=0&id=2e1b1edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports